import Controller from 'controllers/controller';
import CarouselController from 'controllers/components/carousel';
import Elements from 'tools/elements';

/**
 * @class CarouselsController - This controller finds carousels on the page, and initialises individual
 * CarouselController classes for each.
 */
class CarouselsController extends Controller {
    ready() {
        this.carouselControllerInstances = [ ];
        this.elements = new Elements;
        
        this.cacheElements();
        this.initCarousels();
    }

    cacheElements() {
        this.elements.queryAll('carousels', '.carousel:not(.carousel-init)');
    }
    
    initCarousels() {
        this.elements.each('carousels', carousel => {
            carousel.classList.add('carousel-init');
            
            this.carouselControllerInstances.push(
                this.app.make(CarouselController, carousel)
            )
        })
    }
}

export default CarouselsController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/carousels.js